export default __webpack_public_path__ + "resources/icons/d240-4481.webp";